var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#E70000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99793 8L11.7912 5.20674C11.9238 5.0744 11.9983 4.89483 11.9985 4.70751C11.9987 4.5202 11.9244 4.34049 11.7921 4.20793C11.6597 4.07536 11.4802 4.00079 11.2929 4.00062C11.1055 4.00046 10.9258 4.07471 10.7933 4.20704L8 7.00031L5.20674 4.20704C5.07417 4.07448 4.89437 4 4.70689 4C4.51941 4 4.33961 4.07448 4.20704 4.20704C4.07448 4.33961 4 4.51941 4 4.70689C4 4.89437 4.07448 5.07417 4.20704 5.20674L7.00031 8L4.20704 10.7933C4.07448 10.9258 4 11.1056 4 11.2931C4 11.4806 4.07448 11.6604 4.20704 11.793C4.33961 11.9255 4.51941 12 4.70689 12C4.89437 12 5.07417 11.9255 5.20674 11.793L8 8.99969L10.7933 11.793C10.9258 11.9255 11.1056 12 11.2931 12C11.4806 12 11.6604 11.9255 11.793 11.793C11.9255 11.6604 12 11.4806 12 11.2931C12 11.1056 11.9255 10.9258 11.793 10.7933L8.99793 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveFile);
export default __webpack_public_path__ + "static/media/remove_file.d2640be0c238c88addfa476b2c1bc293.svg";
export { ForwardRef as ReactComponent };